//Generated File 
export default class CriteriaValidatorApplicability{
	static readonly AllScreens = `AllScreens`;
	static readonly Documents = `Documents`;
	static readonly MasterFiles = `MasterFiles`;
}
